import e from "@dialpad/dialtone-tokens/layered/themes/tokens-eucalyptus-colors.css?inline";
//#region themes/eucalyptus.js
var t = {
	brand: {
		css: e,
		name: "eucalyptus"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
